import React from 'react';
import { TrustLayout, TrustHero, TrustSection, TrustList, RelatedLinks, TrustCta } from '../components/website/TrustPage';

const AREAS = [
  { title: 'Manhattan' }, { title: 'Brooklyn' }, { title: 'Queens' }, { title: 'The Bronx' }, { title: 'Staten Island' },
  { title: 'Long Island' }, { title: 'Westchester' }, { title: 'Northern New Jersey' },
];

const SERVICES = [
  { title: 'Free consultations', text: 'In your home or at our Brooklyn showroom. We can typically schedule an estimate within 24 hours.' },
  { title: 'Professional measuring', text: 'Recommended for inside-mount shades and all motorized systems.' },
  { title: 'Installation', text: 'Shades, blinds, drapery and motorized systems installed by our team.' },
  { title: 'Service & adjustments', text: 'Motor settings, adjustments and warranty service coordinated from Brooklyn.' },
];

export default function ServiceAreaPage() {
  return (
    <TrustLayout>
      <TrustHero testId="service-area" eyebrow="Where We Work" title="Our Service Area"
        intro="Apollo Shades is based at the Brooklyn Navy Yard and provides consultations, measuring, installation and service across New York City, Long Island, Westchester and northern New Jersey." />
      <TrustSection title="Areas we cover" testId="service-area-list">
        <p>Our team visits homes and businesses throughout these areas for consultations, measuring, installation and service:</p>
        <TrustList items={AREAS} testId="service-area-areas" />
        <RelatedLinks links={[{ to: '/locations/nyc/motorized-shades', label: 'Motorized shades in NYC' }, { to: '/locations/westchester/motorized-shades', label: 'Motorized shades in Westchester' }]} />
        <p className="text-sm text-neutral-500">Not sure if your address is covered? Call us or send a quote request and we will confirm.</p>
      </TrustSection>
      <TrustSection title="What's included" muted testId="service-area-services">
        <TrustList items={SERVICES} testId="service-area-included" />
        <RelatedLinks links={[{ to: '/measuring-installation', label: 'How measuring & installation works' }, { to: '/warranty-service', label: 'Warranty & service' }]} />
      </TrustSection>
      <TrustSection title="Outside our area" testId="service-area-outside">
        <p>Consultations, measuring and installation are provided in the areas above. Outside them, we ship custom shades nationwide to customers who measure their own windows. Our measuring guidance helps you get the sizes right, and every order is reviewed by our Brooklyn team before production.</p>
        <RelatedLinks links={[{ to: '/products/shades', label: 'Browse shades' }, { to: '/fabrics', label: 'Order fabric samples' }]} />
      </TrustSection>
      <TrustSection title="Visit the showroom" muted testId="service-area-showroom">
        <p>1 Brooklyn Navy Yard, Building 33, Suite 201B, Brooklyn, NY 11205</p>
        <RelatedLinks links={[{ to: '/contact', label: 'Directions & contact details' }]} />
      </TrustSection>
      <TrustCta title="Book a visit in your area" text="Tell us about your windows and we will schedule a free consultation, typically within 24 hours." />
    </TrustLayout>
  );
}
